module.exports = __webpack_public_path__ + "img/18.a52d7781.svg";